import { createSlice } from "@reduxjs/toolkit";

const enhancedConditionsDocumentsListByCategories = createSlice({
	name: "enhancedConditionsDocumentsListByCategories",
	initialState: {
		data: [],
	},
	reducers: {
		setEnhancedConditionDocumentsListByCategories: (state, action) => {
			state.data = action.payload;
		},
	},
});

export const { setEnhancedConditionDocumentsListByCategories } = enhancedConditionsDocumentsListByCategories.actions;
export default enhancedConditionsDocumentsListByCategories.reducer;

export const selectEnhancedConditionDocumentsListByCategories = (state) =>
	state.enhancedConditionsDocumentsListByCategories?.data;
